export const COMPANY = {
    name: 'Товарищество с ограниченной ответственностью "Тенгизшевройл"',
    tin: '930440000929',
    address: 'Казахстан, Атырауская обл., г. Атырау, ул. КАНЫШ САТБАЕВ, д. 3',
    certificateSeries: '15001',
    certificateNum: '0010535',
    ndsRegistrationDate: '15.01.2002',
}
export const BankDetails = {
    kbe: '17',
    iik: 'KZ2883201T0300106005',
    bik: 'CITIKZKA',
    bank: 'АО "Ситибанк Казахстан"'
}
export const KzCountry = 'KZ';
export const KztCurrencyCode = 'KZT';
export const USD = 'USD';
export const NOVAT = 'NOVAT';
export const KZVAT12 = 'KZVAT12%';
export const KZVAT0 = 'KZVAT0%';
export const DefaultTCOWarehouseId: number = 2;
export const CommonDataServiceReplayBufferSize = 1;
export const TopParticipantSearchByName = 20;
export const LinkToSharePoint = "https://chevron.sharepoint.com/sites/TCODigital/ProductLines/SCMandFinance/Government%20Connect%20Portal%20docs/Forms/AllItems.aspx?id=%2Fsites%2FTCODigital%2FProductLines%2FSCMandFinance%2FGovernment%20Connect%20Portal%20docs%2FGovernment%20Connect%20Portal%20User%20guides&viewid=5d082f3e%2Defc4%2D4780%2D873b%2Def22ae525ccf&npsAction=createList&ovuser=fd799da1%2Dbfc1%2D4234%2Da91c%2D72b3a1cb9e26%2CNazym%2EKenzhekhojayeva%40tengizchevroil%2Ecom&OR=Teams%2DHL&CT=1744280326025&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI0OS8yNTAzMDIwMTAxMCIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D"
export const KZPublicOfficeBik = 'KKMFKZ2A';
export const NoConnectionToEsf = 'Прервано соединение с ИС ЭСФ.' +"<br>"+'Попробуйте позже';
export const AccountNumberInputsForGA = ['44401.158016.400', '13568.742010', '44401.599010', '44401.581011'];
